import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import { Configurations } from '../../../Utils/Configurations';
import { LineChart, Line, CartesianGrid, XAxis, YAxis, ResponsiveContainer, LabelList } from 'recharts';
import Loading from '../../../Components/Loading/Loading';
import { RelatorioBSMaisAtivas } from 'ebs-orders-reports-react-lib';

import '../Reports.scss';
import ErrorModal from '../../../Components/ErrorModal/ErrorModal';

export default class BSMaisOrdersReport extends Component {

    constructor() {
        super();

        this.getBSMaisActiveOrders = this.getBSMaisActiveOrders.bind(this);
        this.handleOrg = this.handleOrg.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            activeOrders: {
                assinaturas: 0,
                tipoAssinatura: {}
            },
            beneficiaries: {},
            ordersPerDayData: [],
            isLoading: false,
            hasError: false,
            errorMessage: ''
        };

        // this.getBSMaisActiveOrders();
    }

    getBSMaisActiveOrders() {
        const _activeOrders = axios.get(this.Configurations.apiBasePath + `/pedidos/relatorios/bs-mais/ativas?organizacao=` + (this.state.orgSelecionada));

        _activeOrders.then(response => {
            this.setState({
                activeOrders: response.data.ativas,
                beneficiaries: response.data.beneficiarios,
                ordersPerDayData: this._prepareOrdersPerDayChart(response.data.ativas.dtPedidos),
            });
        }).catch(this.handleError).finally(() => this.setState({ isLoading: false }));
    }

    _prepareOrdersPerDayChart(data) {
        return data.map(item => {
            return {
                name: moment(item.data).format('DD/MMM'),
                value: item.total
            }
        })
    }

    ordersPerDayChart() {
        return (
            <div className="card">
                <div className="card-header">
                    Assinaturas por dia (últimos 7 dias)
                        </div>
                <div className="card-body">
                    <Loading show={this.state.isLoading} />
                    <ResponsiveContainer width="100%" height={200}>
                        <LineChart data={this.state.ordersPerDayData} margin={{ top: 25, right: 10, bottom: 5, left: 0 }}>
                            <Line type="monotone" dataKey="value" stroke="#8884d8" strokeWidth={4}>
                                <LabelList dataKey="value" position="top" fill="#666" fontSize={16} offset={15} style={{ fontWeight: 600 }} />
                            </Line>
                            <CartesianGrid vertical={false} stroke="#939598" />
                            <XAxis dataKey="name" type="category" domain={[0, 'dataMax + 20']} fontSize={10} fontWeight={600} stroke="#666" />
                            <YAxis fontSize={10} type="number" domain={[0, 'dataMax + 20']} />
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            </div>
        )
    }

    handleOrg(eValue) {
        this.setState({ isLoading: true, orgSelecionada: eValue, flagBusca: true },
            () => {
                this.getBSMaisActiveOrders();
            }
        );
    }

    handleError(err) { this.setState({ hasError: true, errorMessage: err.message }) }
    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }

    render() {
        const {
            activeOrders,
            beneficiaries,
            hasError, errorMessage, orgSelecionada, flagBusca, isLoading
        } = this.state;
        return (
            <React.Fragment>
                <RelatorioBSMaisAtivas
                    relatorioDados={{ ativas: activeOrders, beneficiarios: beneficiaries }}
                    funcaoAtualizar={() => this.getBSMaisActiveOrders()}
                    isLoading={isLoading}
                    handleOrg={this.handleOrg}
                    orgSelecionada={orgSelecionada}
                    apiBasePath={this.Configurations.apiBasePath}
                    tokenKey={this.Configurations.tokenKey}
                    flagBusca={flagBusca}
                />
                <ErrorModal isOpen={hasError} message={errorMessage} closeErrorModal={this.closeErrorModal} />
            </React.Fragment>
        )
    }
}